import { Trans, useTranslation } from 'react-i18next';

import { IOSShare } from '../../../../../components/SVGIcons/IOSShare';
import { VerticalDots } from '../../../../../components/SVGIcons/VerticalDots';

import styles from './InAppBlockedTooltip.module.scss';

export const InAppBlockedTooltipContent = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div className={styles.InAppBlockedTooltipContent}>
        <p>{t('auth.googleSignInNotSupported')}</p>
        <ul>
          <li data-testid="inapp-blocked-redesign-ios">
            <Trans components={{ bold: <b />, share: <IOSShare /> }} i18nKey="auth.inAppBlockedIos" />
          </li>
          <li data-testid="inapp-blocked-redesign-android">
            <Trans components={{ bold: <b />, dots: <VerticalDots /> }} i18nKey="auth.inAppBlockedAndroid" />
          </li>
        </ul>
      </div>
    </div>
  );
};
